<template>
  <div>
    <slot></slot>
    <div v-if="focus && focus.state == 'ontrack'">
      <div style="display: flex">
        <div>
          <div>
            <timer
              style="transform: scaleX(0.75) scaleY(0.75)"
              @done="handleStartPauseResumeTimer(tool, 'end')"
              :start="start"
              :pause="pause"
              :timeP="timePComp"
            />
            <div style="display: flex; justify-content: center;">
              <input
                type="number"
                v-model="timeP"
                :disabled="start"
                @blur="handleStartPauseResumeTimer(tool, 'blur')"
                style="width:100px"
              />
              <button
                @click="handleStartPauseResumeTimer(tool, 'start')"
                v-if="!start"
                type="button"
                class="btn btn-primary btn-sm"
                :disabled="timePComp <= 0"
              >
                Start
              </button>
              <button
                @click="handleStartPauseResumeTimer(tool, 'pause')"
                v-if="start && !pause"
                type="button"
                class="btn btn-primary btn-lg"
              >
                Pause
              </button>
              <button
                @click="handleStartPauseResumeTimer(tool, 'resume')"
                v-if="start && pause"
                type="button"
                class="btn btn-primary btn-lg"
              >
                Resume
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else-if="focus && focus.state == 'ondeck'">
      <div style="display: flex">
        <div>
          Settings:
          <hr />
          <p>Choose Alarm or Silence</p>
          <p>Notify Me</p>
        </div>
      </div>
    </div>

    <div v-else-if="focus && focus.state == 'stationed'">
      <div style="display: flex">
        STATIONED
      </div>
    </div>

    <div v-else>
      <div style="display: flex">
        <div>
          SPLASH: INVALID STATE
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import timer from "./timer/index.vue";

export default {
  name: "timer-web-component",
  components: {
    timer
  },
  props: {
    tool: {
      type: Object,
      required: false,
      default: () => {}
    },
    focus: {
      type: Object,
      required: false,
      default: () => {}
    },
    user: {
      type: String,
      required: false,
      default: () => ""
    },
    typeaheadApps: {
      type: Array,
      default: () => ["Maps", "Calculator"]
    },
    setTracker: {
      type: Function,
      default: () => () => {}
    }
  },
  methods: {
    handleStartPauseResumeTimer(tool, type) {
      let updatedTool;
      let tracks = tool.tracks;

      if (type === "start") {
        this.start = true;
        tracks[tracks.length - 1] = {
          ...tracks[tracks.length - 1],
          _started_at: new Date()
        };
        updatedTool = { ...tool, tracks };
      } else if (type === "pause") {
        this.pause = true;
        tracks[tracks.length - 1] = {
          ...tracks[tracks.length - 1],
          _paused_at: new Date()
        };
        updatedTool = { ...tool, tracks };
      } else if (type === "resume") {
        this.pause = false;
        tracks[tracks.length - 1] = {
          ...tracks[tracks.length - 1],
          _resumed_at: new Date()
        };
        updatedTool = { ...tool, tracks };
      } else if (type === "blur") {
        if (tool.tracks) {
          updatedTool = {
            ...tool,
            tracks: [...tool.tracks, { _created_at: new Date() }]
          };
        } else {
          updatedTool = { ...tool, tracks: [{ _created_at: new Date() }] };
        }
      } else if (type === "end") {
        this.start = false;
        this.pause = false;
        this.timeP = "0";
        tracks[tracks.length - 1] = {
          ...tracks[tracks.length - 1],
          _end_at: new Date()
        };
        updatedTool = { ...tool, tracks: [...tracks, { _created_at: null }] };
      }
      // this.$store.dispatch('tools/setTrackerInTool', {focusId: this.focus.focusId, userUid: this.$store.getters['user/user'].uid, tool: updatedTool })
      this.setTracker({
        focusId: this.focus.focusId,
        userUid: this.user,
        tool: updatedTool
      });
    }
  },
  computed: {
    toolsetting: {
      set: function(val) {
        this.A.a = val;
      },
      get: function() {
        return this.A.a;
      }
    },
    timePComp() {
      return Number(this.timeP);
    }
  },
  data: function() {
    return {
      start: false,
      pause: false,
      timeP: "30"
    };
  },
  mounted() {}
};
</script>
<style lang="scss" module>
@import "./style.module.scss";
</style>
<style scoped>
.notepad {
  background-color: rgb(255, 242, 204);
  border-radius: 5px;
  width: 100%;
  height: 125px;
}
.card-body {
  overflow-y: auto;
}
</style>
